import React from "react";
import { Link } from "react-router-dom";

export default ({ text }) => (
  <h4 className="no-orders-msg">{`No ${text} details to show.`}</h4>
);
